var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2501 11.25H0.75C0.335999 11.25 0 10.914 0 10.5C0 10.086 0.335999 9.75 0.75 9.75H10.2501C10.6641 9.75 11.0001 10.086 11.0001 10.5C11.0001 10.914 10.6641 11.25 10.2501 11.25Z",
    fill: "#4080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50006 14.9998C6.30798 14.9998 6.11609 14.9267 5.96997 14.7798C5.677 14.4867 5.677 14.0117 5.96997 13.7188L9.19006 10.4988L5.96997 7.27985C5.677 6.98669 5.677 6.51172 5.96997 6.21875C6.26294 5.92578 6.73791 5.92578 7.03107 6.21875L10.7811 9.96875C11.074 10.2617 11.074 10.7367 10.7811 11.0298L7.03107 14.7798C6.88403 14.9267 6.69196 14.9998 6.50006 14.9998Z",
    fill: "#4080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 24C14.8969 24 14 23.103 14 22V3.99996C14 3.14504 14.544 2.38204 15.3539 2.10097L21.3619 0.0979831C22.7059 -0.314004 23.9999 0.683005 23.9999 2.00008V20.0001C23.9999 20.8541 23.4559 21.616 22.647 21.898L16.6369 23.9021C16.4179 23.97 16.215 24 15.9999 24ZM21.9999 1.50002C21.9349 1.50002 21.8799 1.50808 21.821 1.52602L15.838 3.52096C15.6419 3.58907 15.5 3.78701 15.5 3.99996V22C15.5 22.3411 15.8699 22.5711 16.179 22.474L22.1619 20.4791C22.3569 20.411 22.4999 20.213 22.4999 20.0001V2.00008C22.4999 1.72506 22.276 1.50002 21.9999 1.50002Z",
    fill: "#4080FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.00006C8.336 5.00006 8 4.66406 8 4.25006V2.75006C8 1.23303 9.23285 0 10.7499 0H21.9999C22.4139 0 22.7499 0.335999 22.7499 0.75C22.7499 1.164 22.4139 1.5 21.9999 1.5H10.7499C10.0609 1.5 9.5 2.06104 9.5 2.75006V4.25006C9.5 4.66406 9.164 5.00006 8.75 5.00006Z",
    fill: "#4080FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 21.0001H10.7499C9.23285 21.0001 8 19.767 8 18.25V16.75C8 16.336 8.336 16 8.75 16C9.164 16 9.5 16.336 9.5 16.75V18.25C9.5 18.939 10.0609 19.5001 10.7499 19.5001H14.75C15.164 19.5001 15.5 19.8361 15.5 20.2501C15.5 20.6641 15.164 21.0001 14.75 21.0001Z",
    fill: "#4080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorOpened);
export default __webpack_public_path__ + "static/media/door_opened.377b83772348bb9c9237c14f64c3de2c.svg";
export { ForwardRef as ReactComponent };